const env = process.env.NODE_ENV === "development"
    ? process.env
    : (window as any).react_app_env;
export default env;